import { EmbedView } from '../../../components/EmbedView';
import { SingleQueryResults } from '../../../components/QueryResults/SingleQueryResults';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';

/**
 * Historic Royalties "Past Consolidated Statements" tab (agent workspaces only). Embeds the
 * consolidated payment statements view (the "Consolidated Payment Statements"
 * embed from the embed PoC).
 */
export const RoyaltiesStatementSummaries = () => {
  const [, activeWorkspaceQuery] = useActiveWorkspace();

  return (
    <SingleQueryResults query={activeWorkspaceQuery}>
      {(workspace) => (
        <EmbedView
          embedType="consolidated-payments"
          loadingMessage="Loading your consolidated payment statements, please stand by..."
          resourceId={workspace._id}
        />
      )}
    </SingleQueryResults>
  );
};
